import { baseApi } from '../../app/api/baseApi'
const authenticateRequest = ({ system, connectorId, instanceType }) => {
    switch (system) {
        case 'QuickBooks':
            return {
                url: '/Authentication/QuickBooksAuthenticate/',
                params: { subscriptionConnectorId: connectorId, instanceType }
            }
        case 'Shopify':
            return { url: `/Shopify/${connectorId}/Authenticate/${instanceType}` }
        case 'BigCommerce':
            return { url: `/Bigcommerce/${connectorId}/Authenticate/${instanceType}` }
        default:
            return null
    }
}
export const endpointAuthApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getEndpointAuthUrl: builder.mutation({
            queryFn: async (args, api, extraOptions, baseQuery) => {
                const request = authenticateRequest(args)
                if (!request) {
                    return { error: { status: 'UNSUPPORTED', data: `Authentication for ${args.system} is not supported.` } }
                }
                return baseQuery({ ...request, method: 'GET' })
            }
        })
    })
})

export const { useGetEndpointAuthUrlMutation } = endpointAuthApi
